import React, { useEffect, useState } from 'react';
import {
  ALL_MODULES,
  DEFAULT_FIELDS_BY_COLUMN_NAME,
  InlineEdit,
  InlineEditTableWrapper,
  Loader,
  StatusDropdown
} from '@nile/components';
import { useQuery } from '@apollo/client';
import { AccountClient, GET_FIELD } from '@nile/graphql';

function InlineStatusCell(props) {
  const { _ticket, cell, params, hideTag } = props;
  const ticket = _ticket || cell?.row?.original;
  const allProps = params || cell.column;
  const { actions, editable, shouldFreezeCell } = allProps;
  const isCellFreezed = shouldFreezeCell && shouldFreezeCell(cell);

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const { loading } = useQuery(GET_FIELD, {
    client: AccountClient,
    variables: {
      input: {
        module: ALL_MODULES.ticket,
        columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
      }
    },
    onCompleted: (res) => {
      if (res.getField) {
        const fldOptions =
          res?.getField?.options || res?.getField?.fieldOptions;
        const structuredOptions = fldOptions?.map((element) => {
          return {
            ...element,
            name: element?.value,
            value: element?.value,
            label: element?.value
          };
        });
        setOptions(structuredOptions);
      }
    }
  });

  useEffect(() => {
    if (options.length && ticket.status) {
      const optionSelected = options.find(
        ({ value }) => value.trim() === ticket.status.trim()
      );
      setSelectedOption(
        optionSelected || {
          name: ticket.status,
          value: ticket.status,
          label: ticket.status
        }
      );
    }
  }, [options.length, ticket?.status]);

  return (
    <div className="fx fw actr">
      <InlineEditTableWrapper
        className="width-text-with-icon"
        key={cell?.value}
      >
        <InlineEdit
          editable={!isCellFreezed && editable}
          autoSave
          showProgress
          editView={(fieldProps) => {
            if (loading) {
              return <Loader />;
            }
            return (
              <StatusDropdown
                selectedOption={selectedOption}
                options={options}
                updateSelectedProperties={fieldProps.updateFieldState}
                hideTag={hideTag}
              />
            );
          }}
          readView={() => {
            return (
              <StatusDropdown
                editable={!isCellFreezed && editable}
                selectedOption={selectedOption}
                options={options}
                mode="read"
                hideTag={hideTag}
              />
            );
          }}
          onConfirm={(value, callback) => {
            if (actions.save) actions.save(value, ticket, props.data, callback);
          }}
        />
      </InlineEditTableWrapper>
    </div>
  );
}

export default React.memo(InlineStatusCell);
